import React from "react";

// Composant simplifié pour éviter les problèmes de rechargement infini
export const InstallPWA = () => {
  // Ne rien rendre - composant simplifié
  return null;
};
